<template>
    <div class="column is-4 is-offset-4">
        <div class="box">
            <ValidationObserver ref="observer" v-slot="{}">
                <h3 class="title has-text-black">Autentificare</h3>
                <ValidationProvider
                    rules="required|phoneformat|phonedigits:10"
                    name="telefon"
                    v-slot="{ errors, valid }"
                >
                    <b-field
                        class="has-text-left"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                        :message="errors"
                    >
                        <b-input type="text" v-model.trim="phone" placeholder="Numar de telefon"></b-input>
                    </b-field>
                </ValidationProvider>
                <div class="separator"></div>
                <ValidationProvider rules="required" name="password" v-slot="{ errors, valid }">
                    <b-field
                        class="has-text-left"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                        :message="errors"
                    >
                        <b-input
                            type="password"
                            v-model.trim="password"
                            placeholder="Parola"
                            @keypress.native.enter="login"
                        ></b-input>
                    </b-field>
                </ValidationProvider>
                <br />
                <b-button @click="login" :loading="isLoading" type="is-block is-primary is-fullwidth"
                    >Intra in cont</b-button
                >
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
    components: { ValidationObserver, ValidationProvider },
    data: () => ({
        phone: '',
        password: '',
        isLoading: false,
    }),
    methods: {
        async login() {
            const observer = this.$refs.observer;
            const success = await observer.validate();
            if (!success) {
                for (const key of Object.keys(observer.fields).sort()) {
                    if (observer.fields[key].invalid) {
                        observer.refs[key].$el.scrollIntoView();
                        window.scrollBy(0, -200);
                        return;
                    }
                }
            }

            this.isLoading = true;
            try {
                await this.$store.dispatch('family/Login', {
                    password: this.password.trim(),
                    phone: this.phone,
                });
                this.$router.push({
                    path: '/family',
                });
            } catch (err) {
                this.$reportToSentry(err, {
                    extra: {
                        fn: 'familyLogin',
                        params: {
                            event: 'familyLogin',
                            phone: this.phone,
                            password: this.password,
                            err,
                        },
                    },
                });
                return false;
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style scoped>
.separator {
    display: block;
    padding: 8px 0;
}

::v-deep .input {
    font-size: 0.9rem;
}
</style>
